<template>
  <div class="find_home" style="background: rgb(250, 245, 230);min-height: 100vh;">
    <gcLoading :is-show="loadingShow" />
    <gc-guide :down-show="downShow" @showDwon="getWechat" />
    <div class="banner" style="padding:0;width:100%;background: rgb(250, 245, 230);">
      <img src="https://static.mingchu.co/webapp/xintan/banner.png" alt="">
    </div>
    <div v-if="share.uid" class="center">
      <div class="cenTitle">我正在参与！</div>
      <div class="cenXin">
        <div>欣探行动･酱香大师挑战赛</div>
        <div><span /> 寻找星级杭州味道</div>
      </div>
      <div class="user_img">
        <div class="imgs">
          <img :src="share.head_pic_url" alt="">
          <img v-if="share.auth_icon" class="icon_auth" :src="share.auth_icon" alt="">
        </div>
      </div>
      <div class="user_name">{{ share.nick_name }}</div>
      <div class="Number">当前已有  <span>{{ share.count }}</span>  名厨师参与</div>
      <div class="rewards">
        <div class="rewardTitle">活动奖励</div>
        <div>•<span class="span_block"/>杭州米其林指南发布庆典门票×1张</div>
        <div>•<span class="span_block"/>探访杭州新晋米其林餐厅×6名 </div>
        <div>•<span class="span_block"/>名厨MINGCHU 定制周边&积分 </div>
      </div>
      <div class="immediately" @click="participate()">查看活动详情</div>
    </div>
    <div v-else class="center content">
      <div class="Number">当前已有  <span>{{ share.count }}</span>  名厨师参与</div>
      <div class="activityRewards">活动奖励</div>
      <div class="rewardCont">
        <Reward />
      </div>
      <div class="immediately" @click="participate()">查看活动详情</div>
    </div>
    <div class="smalllogo">
      <BottomLogo :text-show="false" />
    </div>
    <ShareInfo :share-info="shareInfo" />
  </div>
</template>
<script>
import { reactive, toRefs, onBeforeMount } from 'vue'
import { useRouter } from 'vue-router'
import utils from '@/utils/utils'
import config from '@/config/config'
import { ajaxHttp } from '@/api/api'
import ShareInfo from '@/components/shareInfo.vue'
import BottomLogo from '../components/BottomLogo'
import Reward from '../components/Reward'

import { Toast } from 'vant'
import gcLoading from '@/components/gc-loading'

export default {
  name: 'Share',
  components: {
    gcLoading,
    ShareInfo,
    BottomLogo,
    Reward
  },
  setup() {
    const router = useRouter()
    const state = reactive({
      shareInfo: { share_title: '', share_desc: '', share_img: '', share_link: '' },
      loadingShow: true,
      share: {},
      downShow: false,
      uid: 0
    })
    onBeforeMount(() => {
      Uidlist()
    })
    const Uidlist = () => {
      ajaxHttp.$get(`/api/explore/share_info`).then(res => {
        if (res.code === 1) {
          state.shareInfo.share_title = res.data.share_title
          state.shareInfo.share_desc = res.data.share_desc
          state.shareInfo.share_img = res.data.share_img
        } else {
          Toast(res.message)
        }
      })
      ajaxHttp.$get(`/api/explore/share`, { uid: router.currentRoute.value.query.id }).then(res => {
        if (res.code === 1) {
          state.shareInfo.share_link = `${config.webapplink}/riseActivity/xintan/xinshare?id=${res.data.uid}`
          state.share = res.data
          state.loadingShow = false
        } else {
          state.loadingShow = false
          Toast(res.message)
        }
      })
    }
    const participate = () => {
      const u = navigator.userAgent
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
      if (utils.is_weixn()) {
        if (!isAndroid) {
          utils.goDown('H5', `${config.webapplink}/riseActivity/xintan/xinrule`)
        } else {
          state.downShow = true
        }
      } else {
        utils.goDown('H5', `${config.webapplink}/riseActivity/xintan/xinrule`)
      }
    }
    const getWechat = () => {
      state.downShow = false
    }
    return { ...toRefs(state), participate, getWechat }
  }
}
</script>
<style lang="scss" scoped>
.span_block{display:inline-block;width:6px;}
.content{
  .Number{padding:20px 0px;}
  .activityRewards{color: #666666;font-weight: bold;font-size: 16px;text-align:center;}
  .rewardCont{padding:8px 9px 20px 8px;}
}
.center{
  border-radius: 8px;position: relative;top:-112px; margin: 0 15px;background: #FFFFFF;
  .cenTitle{
    color: #333333;font-size: 18px;font-weight: bold;width: 100%;text-align: center;padding-top: 22px;
  }
  .cenXin{
    color: #C9A128;font-size: 18px;font-weight: bold;text-align:center;
    span{width:35px;height:2px;background: #C9A128;display:inline-block;position: relative;top:-5px;}
  }
  .user_img{
      display:flex;justify-content:center;
      .imgs{
        width: 72px;height: 72px;position:relative;margin-top:15px;
        img{width: 72px;height: 72px;border-radius: 50%;}
        .icon_auth{width:18px;height:18px;position:absolute;bottom:0;right:4px;}
      }
  }
  .user_name{text-align: center;color: #333333;font-size: 16px;padding:8px 52px 31px 52px;}
  .Number{width: 100%;text-align: center;color: #333333;font-size: 20px;font-weight: bold;
    span{
      color:#C99700;
    }
  }
  .rewards{margin: 20px 0  16px 27px;font-size: 12px;color: #666666;
    .rewardTitle{
      font-size: 16px;font-weight: bold;padding-bottom: 4px;
    }
  }
  .immediately{width: 100%;height: 56px;background: #C99700;border-radius: 0px 0px 8px 8px;color: #FFFFFF;font-size: 16px;line-height: 56px;font-weight: bold;text-align: center;}
}
.smalllogo{width: 100%;margin-top:-112px;}
</style>
